module.exports = __webpack_public_path__ + "img/stm-no-title.e2dff6eb.png";